




















import Vue from 'vue';
import PaymentForm, { CardFormResult } from '@/parts/util/PaymentForm.vue';
import { createPaymentInfomation } from '@/api/UserProfile';
import { createPaymentInfomationCorporation } from '@/api/Corporation';
import { CreatePaymentInformationRequest} from '@/api/dto/UserProfile';
import { CreatePaymentInformationCorporateRequest } from '@/api/dto/Corporation';
import { UserProfile } from "@/api/dto/UserProfile";
import { getUserProfile } from "@/api/UserProfile";
import { GetUserProfileResponse } from "@/api/dto/UserProfile";
import FooterSimple from '@/parts/common/FooterSimple.vue';

interface Data {
  profileData: GetUserProfileResponse;
}

const toCreatePaymentInformationRequest = (result: CardFormResult): CreatePaymentInformationRequest => {
  return {
    cardToken: result.cardForm!.cardToken,
  };
}

export default Vue.extend({
  name: 'SettingsPayment',
  components: {
    PaymentForm,
    FooterSimple,
  },
  data(): Data {
    return {
      profileData: {} as GetUserProfileResponse,
    }
  },
  async beforeRouteEnter(to, route, next) {
    const userProfRes = await getUserProfile();
    next((vm) => {
      (vm.$data as Data).profileData = userProfRes;
    });
  },
  methods: {
    async onClickSubmit() {
      var result = await (this.$refs.paymentForm as any).validation() as CardFormResult;
      if(result.message) {
        this.$emit('errorToast', result.message);
        return;
      }
      try {
        // 決済情報登録API実行
        if (this.profileData.userCategory == '3') {
          await createPaymentInfomationCorporation(toCreatePaymentInformationRequest(result));
          this.$store.dispatch('userUpdate');
          this.toCorporateAccountSettings();
        } else {
          await createPaymentInfomation(toCreatePaymentInformationRequest(result));
          // ユーザー情報取得し更新
          this.$store.dispatch('userUpdate');
          this.toAccountSettings();
        }
        this.$emit('toast', '決済情報を登録しました');
      } catch (e) {
        this.$emit('errorToast', '決済情報の登録に失敗しました。');
      }
    },
    toAccountSettings() {
      this.$router.push({name:'Settings',params:{modeName:'account'}});
    },
    toCorporateAccountSettings() {
      this.$router.push({name:'AccountInfo',params:{modeName:'account'}});
    },
    async getUserProfile() {
      try {
        const res = await getUserProfile();
        this.profileData = {
          ...res,
          // 表示名が空の場合、ユーザーIDを表示する
          nickname: res.nickname ? res.nickname : this.$store.state.user.userId,
        };
        // ページ離脱時に編集有無を確認するために、現在のプロフィール情報を保持しておく
      } catch (e) {
        console.log(e);
      }
    },
  }
})
